import { Form, Modal } from "react-bootstrap";
import "./View_Rating_Modal.css";
import Successfull_Lottie from "../../../animation/successfull_lottie/Successfull_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import {
  faPencil,
  faPlus,
  faXmark,
  faStar as solidStar,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import { useForm } from "react-hook-form";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import { useDispatch } from "react-redux";
import { getSingleReview, reviewPUT } from "../../../../features/reviewRating/reviewRatingSlice";
import { IDS } from "../../../../utils/IDS";

const View_Rating_Modal = ({ setShowSucsessModal, ...props }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ratings: 1,
      review: "",
    },
  });

  const [review, setReview] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const generateStars = (rating = 1) =>
    Array(5).fill(0).map((_, i) => (i < rating ? 1 : 0));

  const getReviews = async (id) => {
    const res = await dispatch(getSingleReview(id));

    if (res?.payload?.data) {
      const data = res.payload.data;

      await setReview(data);

      reset({
        review: data.review,
        ratings: data.ratings,
      });



      setRatings(generateStars(data.ratings));
    }
  };

  useEffect(() => {
    if (props?.show) {
      getReviews(props.show);
    }
  }, [props?.show]);

  useEffect(() => {
    if (!props.show) {
      setReview(null);
      setRatings([]);
      setIsEdit(false);
      setSelectedFiles([]);
      reset();
    }
  }, [props.show]);

  const handleStarClick = (starIndex) => {
    setRatings(generateStars(starIndex));
    setValue("ratings", starIndex);
  };

  const renderStars = () =>
    ratings.map((rating, index) => (
      <FontAwesomeIcon
        key={index}
        icon={rating ? solidStar : regularStar}
        className="star-icon me-1"
        onClick={() => handleStarClick(index + 1)}
        style={{ cursor: "pointer" }}
      />
    ));

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prev) => [...prev, ...files]);
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const onEditSubmit = async (data) => {
    console.log("UPDATED DATA:", data);
    console.log("UPDATED selectedFiles:", selectedFiles);

    const DataToSend = new FormData();
    DataToSend.append("ratings", data.ratings);
    DataToSend.append("review", data.review);
    if (selectedFiles && selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        DataToSend.append("images", selectedFiles[i]);
      }
    }
    for (let pair of DataToSend.entries()) {
      console.log(pair[0], pair[1]);
    }
    // props?.o nHide();
    const res = await dispatch(reviewPUT({ id: props?.show, data: DataToSend }));


    if (res.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      setShowSucsessModal(true);
      reset();
      setSelectedFiles([]);
      setTimeout(() => {
        setShowSucsessModal(false);
      }, 2000);

    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const images =
    review?.Review_Images?.filter((img) => img?.image) || [];

  return (
    <Modal className="View_Rating_Modal" size="lg" {...props} centered>
      <Modal.Body>

        {/* SUCCESS HEADER */}
        {!isEdit && review && (
          <div className="success_div">
            <div className="absolute_div">
              <div className="animation_holder">
                <Successfull_Lottie />
              </div>
            </div>

            <p className="success_text">
              Reviews And Ratings Submitted Successfully! Thank You!
            </p>
          </div>
        )}

        {!review ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            Loading review...
          </div>
        ) : (
          <div className="review_info_div">
            {!isEdit ? (

              <div className="content_div">
                <p className="section_title_text">Your Review</p>
                <p className="sub_text">{review?.review}</p>

                <p className="section_title_text">Your Ratings</p>
                <div className="rating_div">{renderStars()}</div>

                <p className="section_title_text">Attached Media</p>

                {images.length ? (
                  <div className="image_holder">
                    {images.map((img, i) => (
                      <div
                        className="file_img_holder"
                        key={img?.id ?? i}
                      >
                        {img.image.match(/\.(mp4|webm|ogg)$/i) ? (
                          <video
                            className="img_logo"
                            controls
                            preload="metadata"
                          >
                            <source
                              src={`${IDS.IMG_URL}${img.image}`}
                            />
                          </video>
                        ) : (
                          <img
                            src={`${IDS.IMG_URL}${img.image}`}
                            className="img_logo"
                            alt="review"
                            loading="lazy"
                            onError={(e) => {
                              e.target.src =
                                "/assets/images/no-image.png";
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No media uploaded</p>
                )}

                <div className="btn_holder">
                  <Pink_Btn btnText={"OK"} onClick={props.onHide} />
                </div>

                <div
                  className="edit_icon_holder"
                  onClick={() => setIsEdit(true)}
                >
                  <FontAwesomeIcon
                    icon={faPencil}
                    className="edit_icon"
                  />
                </div>
              </div>
            ) : (


              <div className="edit_rating_div content_div">
                <p className="section_title_text">Your Review</p>

                <Form.Group className="gray_input_group">
                  <Form.Control
                    as="textarea"
                    {...register("review", {
                      required: "Review is required",
                    })}
                  />
                  {errors.review && (
                    <p className="text-danger">
                      {errors.review.message}
                    </p>
                  )}
                </Form.Group>

                <p className="section_title_text">Your Ratings</p>
                <div className="rating_div">{renderStars()}</div>

                <p className="section_title_text">Attached Media</p>

                <div className="rating">
                  <div className="two_content_holder">
                    <Form.Label className="plus-btn">
                      <FontAwesomeIcon icon={faPlus} />
                      <Form.Control
                        type="file"
                        onChange={handleFileChange}
                        multiple
                        accept="image/*,video/*"
                      />
                    </Form.Label>

                    <div className="image_holder">

                      {/* Existing Images */}
                      {/* {images.map((img, i) => (
                        <div
                          className="file_img_holder"
                          key={`old-${img?.id ?? i}`}
                        >
                          <img
                            src={`${IDS.IMG_URL}${img.image}`}
                            className="img_logo"
                            alt="review"
                          />
                        </div>
                      ))} */}

                      {/* New Files */}
                      {selectedFiles.map((file, index) => (
                        <div
                          className="file_img_holder"
                          key={`new-${index}`}
                        >
                          <object
                            className="img_logo"
                            data={URL.createObjectURL(file)}
                            type={file.type}
                          />

                          <div
                            className="cross_overlay"
                            onClick={() =>
                              handleRemoveImage(index)
                            }
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="two_btn_holder">
                  <Pink_Btn
                    btnText={"Submit"}
                    onClick={handleSubmit(onEditSubmit)}
                  />
                  <Light_Black_Btn
                    btnText={"Cancel"}
                    onClick={() => setIsEdit(false)}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default View_Rating_Modal;
